import { render, staticRenderFns } from "./SignUpCompany.vue?vue&type=template&id=ae939736&scoped=true"
import script from "./SignUpCompany.vue?vue&type=script&lang=js"
export * from "./SignUpCompany.vue?vue&type=script&lang=js"
import style0 from "../_layout.css?vue&type=style&index=0&id=ae939736&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae939736",
  null
  
)

export default component.exports